import { defineMessages } from "react-intl";

export default defineMessages({
  exportFailedTitle: {
    defaultMessage: "Product Export Failed"
  },
  exportFinishedText: {
    defaultMessage:
      "Product export has finished and was sent to your email address."
  },
  exportFinishedTitle: {
    defaultMessage: "Exporting CSV finished",
    description: "csv file exporting has finished, header"
  },
  invoiceGenerateFinishedText: {
    defaultMessage:
      "Requested Invoice was generated. It was added to the top of the invoice list on this view. Enjoy!"
  },
  invoiceGenerateFinishedTitle: {
    defaultMessage: "Invoice Generated",
    description: "invoice generating has finished, header"
  },
  invoiceGenerationFailedTitle: {
    defaultMessage: "Invoice Generation",
    description: "dialog header, title"
  },
  shopifySyncFailedText: {
    defaultMessage: "Shopify sync was unsuccessful."
  },
  shopifySyncFailedTitle: {
    defaultMessage: "Shopify Sync Failed."
  },
  shopifySyncFinishedText: {
    defaultMessage: "Shopify sync successful!"
  },
  shopifySyncFinishedTitle: {
    defaultMessage: "Shopify Sync Finished"
  },
  uploadFailedTitle: {
    defaultMessage: "Product Upload Failed"
  },
  uploadFinishedText: {
    defaultMessage: "Product upload has finished."
  },
  uploadFinishedTitle: {
    defaultMessage: "Upload finished",
    description: "csv file upload has finished, header"
  },
  voucherBulkJobFailedText: {
    defaultMessage: "Bulk Update Voucher Group Failed"
  },
  voucherBulkJobFailedTitle: {
    defaultMessage: "Bulk Update Voucher Group Failed"
  },
  voucherBulkJobFinishedText: {
    defaultMessage: "Bulk Update Voucher Group Success"
  },
  voucherBulkJobFinishedTitle: {
    defaultMessage:
      "Bulk Update Group Status for Bulk Voucher Group has been updated."
  },
  voucherJobFailedText: {
    defaultMessage: "Bulk Voucher Failed"
  },
  voucherJobFailedTitle: {
    defaultMessage: "Bulk Voucher Failed"
  },
  voucherJobFinishedText: {
    defaultMessage: "Bulk Voucher Success"
  },
  voucherJobFinishedTitle: {
    defaultMessage: "Bulk Voucher Finished"
  }
});
